<footer class="page-footer font-small  lighten-3 pt-3" id="footer">
  <!-- Footer Links -->

  <div class="container text-center">
    <div class="row rowheader text-center justify-content-center contactFooter">
      <h5>Please feel free to write to us at 
        <a  href="mailto:asd.support@accenture.com"
         class="text-lowercase font-weight-bold"
          style="text-decoration:underline"> asd.support@accenture.com </a>
           for application support.</h5>
      <h5> There is a dedicated support team working from India Delivery Centre.</h5>

    </div>

  </div>
  <hr>

  <div class="container-fluid text-center ">
    <!-- Grid row -->


    <div class="row text-center justify-content-center">

      <a href="#" class="pl-3 pr-3 pb-2  text-uppercase">Home</a>
      <a data-toggle="modal" data-target="#modalDefaultContactForm" (click)=" getContactElementDetails();"
        class="footerBorder pl-3 pr-3  text-uppercase">Contact Us</a>
     
      <a (click)=" getElementDetails('hana');" data-target="#scrollModal" data-toggle="modal"
        class="footerBorder pl-3 pr-3  text-uppercase" mdbWavesEffect>S/4 Hana</a>
      <a (click)="getElementDetails('ecc');" data-target="#scrollModal" data-toggle="modal"
        class="footerBorder pl-3 pr-3  text-uppercase">ECC</a>
      <a (click)=" getElementDetails('bw');" data-target="#scrollModal" data-toggle="modal"
        class="footerBorder pl-3 pr-3  text-uppercase">BW</a>
      <a (click)=" getElementDetails('apo');" data-target="#scrollModal" data-toggle="modal"
        class="footerBorder pl-3 pr-3  text-uppercase">APO</a>
     
      <a (click)=" getElementDetails('utilities');" data-target="#scrollModal" data-toggle="modal"
        class="footerBorder pl-3 pr-3  text-uppercase">IS-Utilities</a>
      <a (click)=" getElementDetails('upstream');" data-target="#scrollModal" data-toggle="modal"
        class="footerBorder pl-3 pr-3  text-uppercase">IS Energy-Upstream</a>
      <a (click)=" getElementDetails('downstream');" data-target="#scrollModal" data-toggle="modal"
        class="footerBorder pl-3 pr-3  text-uppercase">IS Energy-Downstream</a>

    </div>
  </div>

 

  <hr class="clearfix w-100 d-md-none pb-3">




  <div class="footer-copyright text-center ">
  
    &copy; {{copyright}}

  </div>
 

</footer>
